import { z } from 'zod';
import { TIPOS_CAMPANA, TIPOS_CAMPANA_ATRIBUCION } from '../enums.js';
// ---------------------------------------------------------------------------
// Campaña — de dónde vienen los leads, como dato (Ciclo 1b, R5).
// META_ADS se reconoce por el texto prefijado del anuncio (o el metadato);
// REAPERTURA por estar vigente en la instancia cuando llega el primer mensaje.
// ---------------------------------------------------------------------------
export const campanaPublicSchema = z.object({
    id: z.string(),
    nombre: z.string(),
    tipo: z.enum(TIPOS_CAMPANA),
    // Nombres de instancia por los que corre ("Metamorfosis 1", "Metamorfosis 2").
    instancias: z.array(z.string()),
    // Textos que identifican al lead (el prefijado del anuncio). Vacío en REAPERTURA.
    textos: z.array(z.string()),
    vigenteDesde: z.string(),
    vigenteHasta: z.string().nullable(),
    activa: z.boolean(),
    creadoEn: z.string(),
    // Cuántos leads quedaron sellados con esta campaña.
    leads: z.number().int(),
});
export const campanaCrearSchema = z.object({
    nombre: z.string().trim().min(2).max(80),
    tipo: z.enum(TIPOS_CAMPANA_ATRIBUCION),
    instancias: z.array(z.string().trim().min(1)).min(1),
    textos: z.array(z.string().trim().min(3).max(1000)).default([]),
    vigenteDesde: z.coerce.date(),
    vigenteHasta: z.coerce.date().nullable().optional(),
    activa: z.boolean().default(true),
});
export const campanaActualizarSchema = z
    .object({
    activa: z.boolean(),
    vigenteHasta: z.coerce.date().nullable(),
    textos: z.array(z.string().trim().min(3).max(1000)),
})
    .partial();
// Sella con la campaña a los leads sin campaña cuyo primer entrante es >= desde.
export const campanaSellarSchema = z.object({
    desde: z.coerce.date(),
});
export const campanaSellarResultadoSchema = z.object({
    sellados: z.number().int(),
});
//# sourceMappingURL=campana.js.map